import LoadPostError from './LoadPostError';

export default LoadPostError;
